import { defineStore } from 'pinia'

import { useAjax } from '@composables/useAjax.js'

// const property = ref(null)
let activeCode = null
let cache = {}
let paths = {}

export const useStore = defineStore('properties', {
  state: () => ({
    activeBy: null,
    activeProperty: null, // MAPでポップアップ表示している物件
    properties: null, // 物件一覧（コードとパスのみ）
    cities: null
  }),

  actions: {
    /**
     * アクティブ状態の設定
     */
    async active(code, by) {
      activeCode = code
      if (!cache[code]) {
        await useStore().getProperty(code)
      }

      if (activeCode == code) { // 物件情報を取得している最中にアクティブな物件が変わる可能性がある
        this.activeProperty = cache[code]
        this.activeBy = by
      }
    },

    /**
     * 物件情報の取得
     */
    async getProperty(code) {
      const { callGet } = useAjax()
      const response = await callGet(paths[code])
      if (response.property) {
        cache[response.property.code] = response.property
      }
      return response
    },

    /**
     * 物件一覧の取得
     */
    async getProperties() {
      const { callGet } = useAjax()
      const url = new URL(location.href)
      url.pathname = `${url.pathname.replace(/\/$/, '')}.json`
      url.searchParams.delete('page')
      url.searchParams.delete('m')
      url.searchParams.append('u', window.app.common.cacheKey[window.app.page.type])
      const response = await callGet(url.toString())

      if (response.properties && response.properties.length > 0) {
        this.properties = response.properties
        this.cities = response.cities
        this.properties.forEach((property) => paths[property.code] = property.path)
      }
      else {
        this.properties = []
      }
    },

    /**
     * アクティブ状態の解除
     */
    resetActive() {
      this.activeProperty = null
    },
  },
})
